// Core
import { ReactNode } from 'react';
// Packages
import cx from 'classnames';
// I18n
import { t } from 'i18n';
// Styles
import styles from './skeleton.module.scss';

interface ISkeletonProps {
  className?: string;
  children: ReactNode;
}

interface ISkeletonBlockProps {
  className?: string;
}

/**
 * A group of placeholder blocks shaped like the content that is loading. The whole group pulses as
 * one (one animation, not one per block) and stays still when the OS asks for reduced motion.
 * Screen readers hear one "Loading…" status instead of the shapes: a live region is read out by
 * its text (a label is not announced, and aria-busy would hold the announcement back).
 */
const Skeleton = ({ className, children }: ISkeletonProps) => (
  <div role="status" className={cx(styles.skeleton, className)}>
    <span className={styles.visuallyHidden}>{t('common.loading')}</span>
    {children}
  </div>
);

/** One placeholder bar; size it with a class (12px tall and full width by default). */
export const SkeletonBlock = ({ className }: ISkeletonBlockProps) => (
  <span aria-hidden="true" className={cx(styles.block, className)} />
);

export default Skeleton;
